import React, { useState, useMemo } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Flex, Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import PartyIcon from "./PartyIcon";
import { PiMoneyBold } from "react-icons/pi";
import { calculatePriceForParty } from "../common/helper";
const CardList = ({ experiences, handleClick, partyType, partySize }) => {
  const [visibleExperiences, setVisibleExperiences] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const batchSize = 30;

  useMemo(() => {
    setVisibleExperiences(experiences.slice(0, batchSize));
    setHasMore(experiences.length > batchSize);
  }, [experiences]);

  const fetchMoreData = () => {
    const nextExperiences = experiences.slice(
      visibleExperiences.length,
      visibleExperiences.length + batchSize
    );

    if (nextExperiences.length === 0) {
      setHasMore(false);
      return;
    }

    setVisibleExperiences((prevExperiences) => [
      ...prevExperiences,
      ...nextExperiences,
    ]);
  };

  return (
    <InfiniteScroll
      dataLength={visibleExperiences.length}
      next={fetchMoreData}
      hasMore={hasMore}
      loader={<h4>Loading...</h4>}
      endMessage={<p></p>}
    >
      <Flex
        wrap="wrap"
        justify="space-around"
        style={{ padding: "1.5rem", margin: 0 }}
        className="body-flex"
        gap={"large"}
      >
        {visibleExperiences?.map((item, index) => (
          <div
            style={{
              width: "19rem",
              marginBottom: "2rem",
              margin: "0",
              borderRadius: "0.4rem",
              overflow: "hidden",
              cursor: "pointer",
              border: "1px solid lightgrey",
            }}
            key={index}
            onClick={() => handleClick(item)}
          >
            <div
              style={{
                height: "12rem",
                width: "100%",
              }}
            >
              <img
                src={item?.coverPhotos && item?.coverPhotos[0]?.image}
                style={{
                  height: "12rem",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
            </div>

            <Flex
              gap={"medium"}
              justify="space-between"
              style={{ padding: "1rem" }}
              vertical
            >
              <Typography.Text style={{ minHeight: "4rem" }} strong>
                {item.experienceName}
              </Typography.Text>
              <Flex justify="flex-end" vertical>
                <Flex style={{ color: "grey" }} gap={"small"}>
                  <EnvironmentOutlined />
                  <Typography.Paragraph
                    style={{
                      paddingTop: "0.8rem",
                      fontWeight: "500",
                      color: "grey",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    {item?.location?.formatedAdd}
                  </Typography.Paragraph>{" "}
                </Flex>
                <Flex style={{ color: "grey" }} gap={"small"} align="center">
                  <PartyIcon partyType={item.experienceType} />
                  <Typography.Text style={{ fontWeight: "500", color: "grey" }}>
                    {item.experienceType}
                  </Typography.Text>
                </Flex>
                <div style={{ height: "0.9rem", width: "0.9rem" }}></div>
                <Flex style={{ color: "grey" }} gap={"small"} align="center">
                  <div
                    style={{
                      height: "1rem",
                      width: "1rem",
                      marginTop: "-2px",
                      color: "grey"
                    }}
                  >
                    <PiMoneyBold />
                  </div>
                  <Typography.Text
                    style={{
                      fontWeight: "500",
                      height: "1rem",
                      color: "grey",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    ${calculatePriceForParty(item.experienceType, item.baseSharedPrice, item.basePrivatePrice, item.extraPersonPrice, partyType, partySize).toFixed(2)} (USD)
                  </Typography.Text>
                </Flex>
              </Flex>
            </Flex>
          </div>
        ))}

        {Array.from({ length: batchSize }, (_, index) => (
          <div
            style={{
              width: "19.15rem",
              minWidth: "19.15rem",
              margin: "0",
              overflow: "hidden",
            }}
            key={index}
          ></div>
        ))}
      </Flex>
    </InfiniteScroll>
  );
};

export default CardList;
